<div class="mt-5">
  <div class="section-title text-center">
    {{ "Resume Builder Available" | translate }}
  </div>
  <div class="row w-100 mt-3 mx-0 justify-content-center mt-5">
    <div class="col-12 col-md-8 col-lg-7 my-auto px-5 order-md-1 order-2">
      <div class="description-title">
        {{ "How to use our resume builder" | translate }}
      </div>
      <div class="description">
        {{ "Most resume builders online" | translate }}
      </div>

      <button class="gradient-button" routerLink="/generatResume">
        {{ "Generate Your CV" | translate }}
      </button>
      <button class="border-button" routerLink="/create-cover-letter">
        {{ "Create a Cover Letter" | translate }}
      </button>
    </div>
    <img
      class="col-8 col-md-4 col-lg-5 text-center p-0 order-md-2 order-1"
      src="../../../assets/img/resume-builder.png"
    />
  </div>
</div>
